<template>
  <aside class="max-pos-detail panel panel-default" data-max-host>
    <div class="panel-heading">
      <h4 class="panel-title">{{ node.title || _('Details') }}</h4>
    </div>
    <div class="panel-body">
      <p v-if="!row" class="text-muted">{{ node.empty || _('Nothing to show.') }}</p>
      <dl v-else class="max-pos-detail__fields">
        <template v-for="field in node.fields" :key="field.key">
          <dt>{{ field.label }}</dt>
          <dd>{{ cell(row[field.key], field) }}</dd>
        </template>
      </dl>
      <button
        v-if="row && node.open"
        type="button"
        class="btn btn-default btn-sm"
        v-on:click="open"
      >{{ _('Open') }}</button>
    </div>
  </aside>
</template>

<script>
import { useMaxContext, useMaxInterface } from '#max-runtime/context.ts'
import { formatValue } from '#max-core'

export default {
  props: ['node'],
  setup () {
    const { $translate } = useNuxtApp()
    return { iface: useMaxInterface(), ctx: useMaxContext(), _: $translate }
  },
  computed: {
    row () {
      return this.node.resolvedRow || null
    }
  },
  methods: {
    cell (value, field) {
      if (typeof value === 'boolean') return value ? '✓' : '–'
      return formatValue(value, {
        format: field.format,
        currency: field.currency,
        locale: this.$store && this.$store.getters.locale,
        labels: this.ctx && this.ctx.labels && this.ctx.labels.catalog
      })
    },
    open () {
      const open = this.node.open
      if (!open || !this.row) return
      this.iface.run([{ do: 'navigate', to: open.to, id: open.id || { var: 'row.id' } }], { ...(this.node.scope || {}), row: this.row })
    }
  }
}
</script>

<style scoped>
.max-pos-detail__fields {
  display: grid;
  grid-template-columns: minmax(80px, 30%) 1fr;
  gap: 6px 12px;
  margin: 0 0 12px;
}
.max-pos-detail__fields dt {
  margin: 0;
  color: #666;
}
.max-pos-detail__fields dd {
  margin: 0;
}
</style>
